import { Pipe, PipeTransform } from '@angular/core';
import { AbsencePlannerEventModel } from '../../../core/models/absence-planner/absence-planner-event.model';
import { UserModel } from '../../../core/models/user/user.model';
import { Interval } from 'date-fns';
import { DateTimeHelper } from '../../calendar/util/date-time-helper';

@Pipe({
  name: 'occupiedSlot',
  standalone: true,
})
export class OccupiedSlotPipe implements PipeTransform {
  /**
   *  Add / remove OccupiedSlotCSSClass CSS class.
   *  This CSS class gets applied to all planner event containers which are occupied.
   */
  transform(member: UserModel, day: Date, plannerEvents: AbsencePlannerEventModel[]): boolean {
    const plannerEventModels = plannerEvents.filter(
      (plannerEvent) => plannerEvent.userId === member.id,
    );

    return plannerEventModels.some((plannerEventModel) => {
      const interval: Interval = {
        start: new Date(plannerEventModel.start).setHours(0, 0, 0, 0),
        end: new Date(plannerEventModel.end).setHours(0, 0, 0, 0),
      };

      return DateTimeHelper.isWithinInterval(day, interval);
    });
  }
}
